import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import {
	AnnouncementPagingInformationModel,
	AnnouncementPreviewItemModel
} from "client/Api/Hub/Announcements/announcementViewer";
import { HubItemTileResourceId } from "../../workspace";

export type LiveInformationAnnouncementResponseModelData = {
	items: LazyLoadPageResult<AnnouncementPreviewItemModel> | null;
	lastPinnedItem: AnnouncementPreviewItemModel | null;
};

export type LiveInformationAnnouncementResponseModel = {
	data: LiveInformationAnnouncementResponseModelData;
	resource: HubItemTileResourceId;
};

export type AnnouncementInterests = {
	items: boolean;
	reactions: boolean;
	comments: boolean;
	lastPinnedItem: boolean;
};

export type LiveInformationAnnouncementRequestModel = {
	resource: HubItemTileResourceId;
	interests: AnnouncementInterests;
};

export type LoadMoreAnnouncementsRequest = {
	categoryIds: readonly number[] | null;
	reactions: boolean;
	comments: boolean;
	lastRetrievedItem: AnnouncementPagingInformationModel;
};

export function list(requestModels: LiveInformationAnnouncementRequestModel[]): Promise<LiveInformationAnnouncementResponseModel[]> {
	return httpClient.post<LiveInformationAnnouncementResponseModel[]>(
		"Workspace/LiveInformation/Announcements",
		requestModels
	);
}

export function listMore(
	model: LoadMoreAnnouncementsRequest,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<AnnouncementPreviewItemModel>> {
	return httpClient.post<LazyLoadPageResult<AnnouncementPreviewItemModel>>(
		"Workspace/LiveInformation/Announcements/More",
		model,
		{ signal }
	);
}
